<template>
  <div class="sbox" v-loading="isLoading" style="min-height: 140px;">
    <div class="sbox-head">
      <span class="bar"></span>
      <span class="title">{{ data.name ? data.name : '加载中' }}</span>
      <span v-if="data.note && data.note !== null && data.note !== ''" class="btn btn-icon-only">
        <el-tooltip class="item" open-delay="200" effect="dark" :content="data.note" placement="right">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </span>
      <div style="display: inline-block;" class="ml10" v-for="condition in data.conditions">
        <el-tooltip v-if="condition.type === 'dateLimit'" open-delay="200" effect="dark" :content="condition.label"
                    placement="bottom">
          <el-date-picker
            v-model="blockSearch[condition.dataIndex]"
            type="daterange"
            size="mini"
            align="right"
            unlink-panels
            range-separator="至"
            style="width: 210px;"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="refresh"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-tooltip>
        <el-select
          v-if="condition.type === 'select'"
          v-model="blockSearch[condition.dataIndex]"
          style="width: 140px;"
          filterable
          clearable
          size="mini"
          @change="refresh"
          :placeholder="'请选择' + condition.label">
          <el-option
            v-for="item in condition.options"
            :key="item.id"
            :label="item.label"
            :value="item.id">
          </el-option>
        </el-select>
        <el-cascader
          v-if="condition.type === 'treeSelect'"
          v-model="blockSearch[condition.dataIndex]"
          :options="condition.options"
          :props:="cascadeProps"
          :show-all-levels="false"
          :collapse-tags="true"
          style="width: 140px;"
          size="mini"
          @visible-change="cascadeVisible"
          @remove-tag="cascadeRemoveTag"
          :placeholder="'请选择' + condition.label">
        </el-cascader>
        <el-input
          v-if="condition.type === 'text'"
          v-model="blockSearch[condition.dataIndex]"
          style="width: 200px;"
          size="mini"
          :placeholder="'请输入' + condition.label">
          <i slot="suffix" @click="refresh" class="search-btn el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="append">
        <el-radio-group class="mr10" v-model="currentTab" @change="shiftAnalyse" size="mini">
          <el-radio-button :key="tab.analyseCode" v-for="tab in data.shiftTabs" :label="tab.analyseCode">
            {{ tab.label }}
          </el-radio-button>
        </el-radio-group>
        <a class="btn btn-icon-only" v-if="hasDetail" @click="toShowDetail" data-role="tooltip" data-oriation="top"
           data-trigger="daiban">
          <el-tooltip open-delay="200" effect="dark" :content="'查看详情'" placement="right">
            <i class="shift-btn el-icon-rank"></i>
          </el-tooltip>
        </a>
        <a class="btn btn-icon-only" @click="refresh" data-role="tooltip" data-oriation="top" data-trigger="daiban">
          <el-tooltip open-delay="200" effect="dark" :content="'刷新'" placement="right">
            <i class="el-icon-refresh refresh-btn"></i>
          </el-tooltip>
        </a>
      </div>
    </div>
    <div class="sbox-body"
         :style="{height: (data.blockHeight && data.blockHeight !== null && data.blockHeight !== 0 ? data.blockHeight : 100) + 'px'}">
      <template v-if="data.analyseCodes && data.analyseCodes !== null && data.analyseCodes.length > 0">
        <template v-if="!isShift">
          <show-analyse v-for="code in data.analyseCodes" :key="code" :param="analyseParam(code)"
                        :style="{width: 100/data.analyseCodes.length + '%', float: 'left'}"></show-analyse>
        </template>
        <template v-else>
          <show-analyse v-for="code in data.analyseCodes" v-if="code === currentTab" :key="code"
                        :param="analyseParam(code)"></show-analyse>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
  import util from '@/libs/util'
  import ShowAnalyse from './show-analyse'
  import analyseUtil from './analyse-util'

  export default {
    components: {ShowAnalyse},
    props: {
      blockId: {
        type: String
      },
      block: {
        type: Object
      },
      search: {
        type: Object,
        default: {}
      }
    },
    name: 'analyse-block',
    data() {
      return {
        cascadeProps: {
          value: 'id',
          multiple: true,
          checkStrictly: false,
          emitPath: false
        },
        data: {},
        currentTab: null,
        isLoading: false,
        isShift: false,
        hasDetail: false,
        blockSearch: {}
      }
    },
    mounted() {
      this.loadBlock()
    },
    methods: {
      toShowDetail: function () {
        analyseUtil.pushSearchStack({search: {...this.search, ...this.blockSearch}}, this)
        let deep = this.$route.query && this.$route.query.deep ? parseInt(this.$route.query.deep) : 0
        util.changeRouter(this, {
          name: 'analyseBoard',
          query: {
            id: this.data.detailBoardId,
            deep: deep + 1,
            boardStackKey: analyseUtil.getBoardStackKey(this)
          }
        })
      },
      cascadeVisible: function (visible) {
        if (!visible) {
          this.refresh()
        }
      },
      cascadeRemoveTag: function () {
        this.$nextTick(() => this.refresh())
      },
      refresh: function () {
        this.$set(this.data, 'analyseCodes', null)
        this.blockId = this.block.id
        analyseUtil.putBlockSearch(this.blockSearch, this, this.block.id)
        this.$nextTick(() => {
          this.loadBlockById()
        })
      },
      shiftAnalyse: function (value) {
        this.currentTab = value
      },
      loadBlock: function () {
        if (this.block && this.block !== null) {
          this.setHistorySearch(this.block)
          this.$nextTick(() => {
            this.data = this.block
            this.isShift = this.block.shiftTabs && this.block.shiftTabs.length > 1
            this.hasDetail = this.block.detailBoardId && this.block.detailBoardId !== null && this.block.detailBoardId !== ''
            if (this.currentTab === null && this.block.shiftTabs && this.block.shiftTabs.length > 1) {
              this.currentTab = this.block.shiftTabs[0].analyseCode
            }
          })
        } else {
          this.loadBlockById()
        }
      },
      setHistorySearch: function (data) {
        let historySearch = analyseUtil.getBlockSearch(this, data.id)
        if (historySearch === null || Object.keys(historySearch).length === 0) {
          return
        }
        for (let i = 0; i < data.conditions.length; i++) {
          if (historySearch[data.conditions[i].dataIndex] === undefined) {
            continue
          }
          this.$set(this.blockSearch, data.conditions[i].dataIndex, historySearch[data.conditions[i].dataIndex])
        }
      },
      loadBlockById: function () {
        this.isLoading = true
        util.ajax.get('/entity/analyse/analyseBlock/block/' + this.blockId).then(res => {
          if (res.data.meta && res.data.meta.errCode === 0) {
            this.setHistorySearch(res.data.data)
            this.data = res.data.data
            this.isShift = this.block.shiftTabs && this.block.shiftTabs.length > 1
            this.hasDetail = res.data.data.detailBoardId && res.data.data.detailBoardId !== null && res.data.data.detailBoardId !== ''
            if (this.currentTab === null && res.data.data.shiftTabs && res.data.data.shiftTabs.length > 1) {
              this.currentTab = res.data.data.shiftTabs[0].analyseCode
            }
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.message})
          }
          this.isLoading = false
        }).catch(err => {
          this.isLoading = false
          console.error('analyse block[' + this.code + '] load error', err)
          this.$notify.error({title: '错误', message: '系统错误'})
        })
      },
      analyseParam: function (code) {
        return {
          configCode: code,
          search: {...this.search, ...this.blockSearch}
        }
      }
    }
  }
</script>

<style scoped>

  body {
    font-family: "PingFang SC", Helvetica, "Helvetica Neue", "Microsoft YaHei", "SimSun", Tahoma, Arial, sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #444;
    background-color: #fff;
  }

  .sbox {
    margin: 7px;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }

  .sbox-head {
    position: relative;
    padding: 10px 20px;
    border-bottom: 1px solid #eee;
  }

  .search-btn {
    color: #475ec2;
    cursor: pointer;
    font-size: 14px;
  }

  .search-btn:hover {
    color: #030c2f;
    font-weight: 700;
  }

  .sbox-body {
    height: 250px;
    margin: 20px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .sbox-head .append {
    top: 50%;
    right: 20px;
    bottom: auto;
    height: 30px;
    margin-top: -15px;
    line-height: 30px;
  }

  .append {
    right: 0;
  }

  .append {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
  }

  .sbox-head .bar {
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    width: 4px;
    height: 16px;
    margin-top: -8px;
    background-color: #475ec2;
  }

  .refresh-btn:hover {
    color: #006DE7;
  }

  .sbox-head .title {
    font-size: 16px;
    font-weight: 600;
    color: #222;
    line-height: 28px;
  }

  .shift-btn:hover {
    color: #475ec2;
  }

  .sbox-head .btn {
    color: #666;
  }

  .btn-icon-only i {
    margin-right: 0;
  }

  .btn-icon-only {
    font-size: 18px;
    color: #222;
  }

  .btn {
    position: relative;
    bottom: 2px;
    font-size: 16px !important;
  }

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/analyse-block.vue